var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetbirdinline = function SvgNetbirdinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 30,
    fill: "none",
    viewBox: "0 0 41 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F68330",
    d: "M28.574 0c-4.854.445-7.27 3.24-8.182 4.653L6.211 29.219H23.32L40.194 0h-11.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F68330",
    d: "M23.331 29.22 0 4.475s26.381-7.09 28.952 15.027l-5.621 9.718"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F35E32",
    d: "m19.868 5.567-7.157 12.4 10.608 11.254 5.621-9.74c-.89-7.602-4.597-11.754-9.072-13.925"
  })));
};
export default SvgNetbirdinline;